// extracted by mini-css-extract-plugin
module.exports = {"register-form":"UserExist_register-form__30HML","register-form__rules":"UserExist_register-form__rules__25GWj"};